import CanvasZoom from './CanvasZoom';
export default CanvasZoom;
